import { Provider } from "mobx-react";
import { useEffect, useState } from 'react';
import { HttpHandler } from "./utils/http-handler";
import { _labelsStoreMock } from "./stores/config/__mocks__/labels.mock";
import { MyCart } from "./containers/MyCart/MyCart.jsx";
import { fetchers, parseFloatI18n } from "@pes-ui/utils";
import { createStore } from "./stores/createStore.js";

import { subscribeToCartTransfer } from './common/commerce-connector/cart-transfer/index';

export const App = ({countryCode,languageCode,appMountPoint, isPublic}) => {
  const [allStores, setAllStores] = useState(null);
  
  const getLabelsAndProducts = (countryCode: string , languageCode: string) => {
    const getProducts = fetchers.getMyProducts({
        countryCode,
        languageCode,
        params: { format: "full" },
      });
    const getLabels = HttpHandler.getLabels(countryCode,languageCode);
    return Promise.all([getLabels, getProducts]);
  }

  const initializeStores = async () => {
    try {
      const [labelsResponse, productsResponse] = await getLabelsAndProducts(countryCode, languageCode);
      if(labelsResponse.error) throw labelsResponse.error;
      const { labels } = labelsResponse;  
      const products = productsResponse?.lists?.flatMap(list => list.products);
      for (let i = 0; i < products.length; i++) {
        products[i].price = parseFloatI18n(products[i].price as string);
      }

      const productData = productsResponse.lists;
      const stores = createStore({
        initialSettings: labels.conf,
        productGroups: productData,
        labelsObj: labels.labels,
        localeObj: { countryCode, languageCode },
        appMountPoint,
        isPublic,
        selectorConfiguration: labels.selectorConfiguration
      });
      setAllStores(stores);

      subscribeToCartTransfer()

    } catch (error) {
      console.log('Error while populating stores', error);
    }
  }
 
  useEffect(()=>{
    initializeStores();
  },[]);

  return  allStores && 
          <> 
            <Provider {...allStores}>
              <MyCart />
            </Provider>
          </>
};